import React, { useEffect } from 'react';
import { createState, useState, Downgraded } from '@hookstate/core';
//import { TextField, InputAdornment, Box } from '@mui/material';
import { Box, TextField } from '@mui/material';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import Helper from '../../utility/helper';
// import validator from 'validator';
// import CKEditor from 'ckeditor4-react';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import Editor from 'ckeditor5-custom-build/build/ckeditor';
import TinyMCEEditor from '../../sharedcomponents/tinymceEditor/tinymce';
import AppConstants from '../../constants/appConstants';
const moduleState = createState({
    editorHTML: '',
    displayName: '',
})

const EditModule = (props) => {
    const eventInfo = useState(null);
    const userInfo = useState(null);
    const state = useState(moduleState);
    const regex = new RegExp('[^\\s]+');
    const [nameErr, setNameErr] = React.useState('');
    const [fromInvitationEmail, setFromInvitationEmail] = React.useState('');
    const [fromEmailErr, setFromEmailErr] = React.useState('');   

    useEffect(() => {
        console.log(props)
        const userEventInfo = Helper.getStorage('eventInfo');
        const guserInfo = Helper.getStorage('userInfo');
        eventInfo.set(userEventInfo);
        userInfo.set(guserInfo);
        state.editorHTML.set(props.moduleInfo.details);
        state.displayName.set(props.moduleInfo.displayName);
        setFromInvitationEmail(props.moduleInfo?.fromInvitationEmail) 
    }, []);

    const validateModuleName = () => {
        let value = state.displayName.get().trim();
        if (value === '') {
            setNameErr('Please Enter Module Name');
            return false
        } else {
            const index = props.moduleList?.findIndex((element) => {
                if (element.actualData.displayName === value) {
                    return true;
                }
            });
            if (!/^[A-Za-z\s]*$/.test(value)) {
                setNameErr('Please Enter Valid Module Name');
                return false;
            }
            else if (index > 0) {
                setNameErr('Duplicate Name Not Allowed')
                return false
            }
            else {
                setNameErr('');
                return true
            };
        }
    };
    const handleClick = () => {
        let value = state.displayName.get().trim();
        console.log(value)
        // if (state.editorHTML.get() == null) {
        //     props.setSnackBarProps({
        //         ...props.snackBarProps,
        //         openSnack: true,
        //         variant: 'error',
        //         message: 'Please Enter Module Information',
        //     });
        // } else 
        if (nameErr.length > 0) {
            setNameErr('Enter Valid Module Name')
        }else if(fromEmailErr.length > 0 && props.moduleInfo && props.moduleInfo.moduleID === AppConstants.EVENT_MODULES.INVITATION) {   
            setFromEmailErr('Please enter valid From Email')
        }
        else {
            let requestObj = {
                eventID: eventInfo.attach(Downgraded).get().eventID,
                moduleID: props.moduleInfo.moduleID,
                details: state.editorHTML.get() ? encodeURIComponent(state.editorHTML.get()) : '',
                createdBy: userInfo.get().userID,
                displayName: state.displayName.get(),
                fromInvitationEmail: fromInvitationEmail
            };

            ApiHelper.post(APIURLConstants.EDIT_MODULE_INFO, requestObj)
                .then((res) => {
                    if (res.data > 0) {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Module Updated successfully',
                        });
                        props.handleCloseModule();
                        props.handleAction();
                        state.editorHTML.set("");
                        state.displayName.set("");
                    }
                })
                .catch((error) => {
                    console.log('error : ', error);
                    let message = '';
                    if (error.response && error.response.status === 401) {
                        message = 'Access denied';
                    } else {
                        message = 'Error while adding Module';
                    }
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                    // props.handleClose();
                    // props.getParticipants();
                });
            //props.handleClose();
        }
    };

    const setEditorValue = (value) => {
        state.editorHTML.set(value);
    }
    const validateFromEmail = (value) => {
        const email = value.trim();
        setFromInvitationEmail(email);
        const flag = Helper.validEmail(email);
        flag
            ? setFromEmailErr('')
            : setFromEmailErr('Please enter valid From Email');
    }
    const renderDialogContent = () => {
        return (
            <>
                <Box
                    sx={{
                        flex: 1,
                        flexDirection: 'row',
                        width: '100%',
                    }}>
                    {/* <CKEditor
                        data={state.editorHTML
                            .attach(Downgraded)
                            .get()}
                        onChange={(event) =>
                            state.editorHTML.set(
                                event.editor.getData()
                            )
                        }
                        config={{
                            removeButtons: 'Subscript,Superscript',
                            extraAllowedContent: '*{*};*(*);span{!color}'
                        }}
                    /> */}
                    <TinyMCEEditor
                        value={state.editorHTML.attach(Downgraded).get()}
                        setValue={setEditorValue}
                    />
                    {/* <CKEditor
                        editor={Editor}
                        config={{
                            image: {
                                upload: ['jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff']
                            },
                            removeButtons: 'Subscript,Superscript',
                            extraAllowedContent: '*{*};*(*);span{!color}'
                        }}
                        data={state.editorHTML
                            .attach(Downgraded)
                            .get()}
                        onChange={(event, editor) => {
                            console.log(event);
                            state.editorHTML.set(
                                editor.getData()
                            )
                        }}
                    /> */}
                </Box>
                <Box sx={{ marginTop: '10px' }}>
                    <TextField
                        fullWidth
                        required
                        sx={{
                            marginTop: 2,
                            marginRight: 2,
                        }}
                        size="small"
                        value={state.displayName.get()}
                        onChange={(e) => {
                            regex.test(e.target.value)
                                ? state.displayName.set(e.target.value)
                                : state.displayName.set(e.target.value.trim());
                            validateModuleName()
                        }}
                        id="outlined-required"
                        label="Module Name"
                        error={nameErr.length > 0 ? true : false}
                        helperText={nameErr.length > 0 ? nameErr : ''}
                    />
                </Box>
                {props.moduleInfo && props.moduleInfo.moduleID === 3 ? <Box sx={{ marginTop: '10px' }}>
                    <TextField
                        fullWidth                        
                        sx={{
                            marginTop: 2,
                            marginRight: 2,
                        }}
                        size="small"
                        value={fromInvitationEmail}
                        onChange={(e) => {
                            validateFromEmail(e.target.value); 
                        }}
                        id="outlined-required"
                        label="From Invitaiton Email"
                        error={fromEmailErr.length > 0 ? true : false}
                        helperText={fromEmailErr.length > 0 ? fromEmailErr : ''}
                    />
                </Box> : null}
            </>
        );
    };
    const renderDialogActions = () => {
        return (
            <ButtonContainer
                handleClick={handleClick}
                handleCancel={props.handleCloseModule}
                buttonText={'Update'}
            />
        );
    };
    return (
        <CustomDialog
            title={props.title}
            handleClose={props.handleCloseModule}
            open={props.open}
            fullWidth={true}
            maxWidth={'sm'}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
            disableEnforceFocus={true}
        />
    );
};

export default EditModule;
